import { html, LitElement, nothing } from "lit";
import { customElement } from 'lit/decorators.js';
import { AtlListGroupTagNames } from "./list-group.props";

@customElement(AtlListGroupTagNames.ContactListGroupItem)
export class AtlContactListGroupItem extends LitElement {

    declare contactRole?: string;
    declare contactName?: string;
    declare pictureSrc?: string;
    declare email?: string;
    declare phone?: string;

    static properties = {
        contactRole: { attribute: "contact-role", type: String },
        contactName: { attribute: "contact-name", type: String },
        pictureSrc: { attribute: "picture-src", type: String },
        email: { type: String },
        phone: { type: String },
    }

    protected override createRenderRoot() {
        return this;
    }

    render() {
        return html`
            <div class="contact">
                <div class="profile-picture">
                    ${this.pictureSrc 
                        ? html`<img src="${this.pictureSrc}" alt="${this.contactName}'s picture" />` 
                        : html`<i class="fa-solid fa-user" aria-hidden="true" style="font-size: 1rem; "></i>`
                    }
                </div>
                <div class="contact-details">
                    ${this.contactName ? html`<h5>${this.contactName}</h5>` : nothing}
                    ${this.contactRole ? html`<p>${this.contactRole}</p>` : nothing}
                    ${this.email ? html`<p><a href="mailto:${this.email}">${this.email}</a></p>` : nothing}
                    ${this.phone ? html`<p>${this.phone}</p>` : nothing}
                </div>
            </div>
        `;
    }    

}